<template>
	<div>
		<el-form
			ref="form"
			:model="info"
			status-icon
			label-position="left"
			label-width="5rem"
			size="mini"
			v-loading="loadings.main"
			@submit.native.prevent
			class="row"
			:rules="rules"
			v-if="hasGetTableDataModel"
		>
			<div :class="'col-md-'+(key.col?key.col:4)" v-for="(key,index) in fields" :key="index">
				<el-form-item :label="dataModels['Transaction'][key.name].show_name" :prop="key.name">
					<field-editor
						v-model="info[key.name]"
						:field-info="dataModels['Transaction'][key.name]"
						:params="key.params"
						:width="key.width"
					></field-editor>
				</el-form-item>
			</div>
			<div class="col-md-4">
				<el-form-item label="总价">{{total_price}}</el-form-item>
			</div>
		</el-form>
		<tx-items v-if="hasGetTableDataModel && info.warehouse._id" v-model="info.items"></tx-items>
		<hr>
		<div class="btn-holder text-center" v-loading="loadings.main">
			<el-button
				size
				type="success"
				:disabled="info.items.length==0"
				@click="handlerPost('edit_outbound')"
			>保存</el-button>
			<el-button
				size
				type="primary"
				:disabled="info.items.length==0"
				v-if="info.status.index==11"
				@click="handlerPost('edit_verify')"
			>审核</el-button>
		</div>
	</div>
</template>

<script>
import Inventory from "@/mixinsApp/Inventory.js";
import TxOp from "@/mixinsApp/TxOp.js";

export default {
	mixins: [Inventory, TxOp],
	data() {
		return {
			loadings: {
				main: false,
				create: false,
				insert: false
			},
			fields: [
				{
					name: "warehouse",
					params: {
						allowCreate: false
					}
				},
				{
					name: "tx_at",
					params: {
						type: "date"
					}
				},
				{
					name: "discount"
				},
				{
					name: "express_fee"
				},
				{
					name: "desc",
					col: 8,
					width: "100%"
				}
			],
			info: {
				_id: "",
				warehouse: {
					name: "",
					_id: ""
				},
				supplier: {
					name: "",
					_id: ""
				},
				show_id: "",
				items: [],
				express_fee: 0,
				discount: 0,
				status: {
					index: 0
				}
			}
		};
	},
	props: {
		recordId: {
			type: String,
			default: ""
		},
		value: {
			type: Object,
			default: null
		}
	},
	methods: {
		doResetAll() {
			this.info = {
				_id: "",
				warehouse: {
					name: "",
					_id: ""
				},
				supplier: {
					name: "",
					_id: ""
				},
				show_id: "",
				items: [],
				express_fee: 0,
				discount: 0,
				status: {
					index: 0
				}
			};
		},
		_doPost(type) {
			this.loadings.main = true;
			this.$axios
				.post(`/inventory/do_tx_edit/${type}/${this.recordId}`, this.info)
				.then(json => {
					this.loadings.main = false;

					this.$message.success("成功");
					if (type == "edit_outbound") {
						this.$router.push({
							name: "Tx-Info",
							params: {
								id: json.data.info._id,
								tab: "info"
							}
						});
					} else {
						this.doResetAll();
						this.activeName = "his";
					}
				})
				.catch(json => {
					this.loadings.main = false;
					this.$message.error(json.data.msg);
				});
		}
	},
	watch: {
		value: {
			handler(val) {
				if (val) {
					this.info = Object.assign({}, val);
				}
			},
			immediate: true
		}
	}
};
</script>
<style lang="scss" scoped>
</style>
